import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';
import { CustomFieldsFormGzDataProvider } from '../dataProvider/CustomFieldsFormGzDataProvider';

export class CustomFieldsFormDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, CustomFieldsFormGzDataProvider);
  }
}
